import React from 'react';
import PropTypes from 'prop-types';

export default function CrumbIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <g data-name='Grupo 151572'>
        <path
          fill={fill}
          d='M18.438 5.308h-8.062L8.517 3.346A1.111 1.111 0 0 0 7.711 3H2.125A1.14 1.14 0 0 0 1 4.154v13.269a.57.57 0 0 0 .562.577h16.876a.57.57 0 0 0 .562-.577V5.885a.57.57 0 0 0-.562-.577ZM2.125 4.154h5.586L9.9 6.462H2.125Z'
          data-name='Caminho 36513'
        />
        <path
          fill='#fff'
          d='M13.372 10.793a.577.577 0 0 0-.347-.534.552.552 0 0 0-.614.125l-2.408 2.471-2.409-2.471a.554.554 0 0 0-.8 0 .588.588 0 0 0 0 .817l2.809 2.878a.553.553 0 0 0 .8 0l2.803-2.878a.584.584 0 0 0 .166-.408Z'
        />
      </g>
    </svg>
  );
}

CrumbIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

CrumbIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
